import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamation } from "@fortawesome/free-solid-svg-icons";
import Button from "../Form/Button";
import "./styles.scss";

interface Props {
  loadingBoleto: boolean;
  inCash?: boolean;
  hasPreviousBillet?: boolean;
  showOverdueWarning?: boolean;
  overdueInstallmentBilletDueDate?: string;
  onCancel(): void;
  onConfirm(): void;
}

export default function AlertGenerateInstallmentsBilletModal({
  loadingBoleto,
  inCash = false,
  hasPreviousBillet = false,
  showOverdueWarning = true,
  overdueInstallmentBilletDueDate,
  onCancel,
  onConfirm,
}: Props) {
  return (
    <div className="content-alert-generate-billet">
      <div className="title">
        <FontAwesomeIcon icon={faExclamation} className="exclamation-icon" />
        <h4>{inCash ? "Gerar boleto à vista" : "Gerar boleto das parcelas"}</h4>
      </div>
      {hasPreviousBillet && (
        <p>
          {inCash
            ? "Uma ou mais CDAs selecionadas já possuem boleto gerado. Ao continuar, o boleto anterior será cancelado. Caso deseje continuar, o boleto anterior será cancelado."
            : "Uma ou mais parcelas selecionadas já possuem boleto gerado. Caso deseje continuar, o boleto anterior será cancelado."}
        </p>
      )}
      {showOverdueWarning && <p>
        {overdueInstallmentBilletDueDate
          ? `O boleto será emitido com vencimento em ${overdueInstallmentBilletDueDate}, dia útil mais próximo, porque existem parcelas vencidas dentre as selecionadas.`
          : "O boleto será emitido com vencimento conforme a regra vigente, porque existem parcelas vencidas entre as selecionadas."}
      </p>}
      <div className="actions">
        <button type="button" className="btn btn-cancel" disabled={loadingBoleto} onClick={onCancel}>
          Cancelar
        </button>
        <Button
          label="Gerar boleto"
          loadingLabel="Gerando boleto..."
          loading={loadingBoleto}
          onClick={onConfirm}
        />
      </div>
    </div>
  );
}
